import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import { CarImportSearch } from '../components/CarImportSearch';
import { CarImportsTable } from '../components/CarImportsTable';
import AppHeader from '../components/AppHeader';
import { useCarImports } from '../hooks/useCarImports';
import { CarImportSearchParams } from '../api/apiClient';

export const HomePage: React.FC = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useState<CarImportSearchParams>({});

  // Fetch data with pagination and search
  const { data, isLoading, error, refetch } = useCarImports({
    ...searchParams,
    page: page,
    limit: rowsPerPage,
  });

  // Handle refetch after uploads
  const handleUploadSuccess = () => {
    refetch();
  };

  const handleSearch = (params: CarImportSearchParams) => {
    setPage(0); // Reset to first page on new search
    setSearchParams(params);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page when changing page size
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <AppHeader onUploadSuccess={handleUploadSuccess} />
      
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4 }}>
          <CarImportSearch onSearch={handleSearch} />
        </Box>

        <CarImportsTable
          data={data?.data || []}
          loading={isLoading}
          error={error}
          page={page}
          rowsPerPage={rowsPerPage}
          totalCount={data?.total || 0}
          searchParams={searchParams}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Container>
    </Box>
  );
};

export default HomePage;
